import { Routes } from '@angular/router';
import { HomeComponent } from './home/home';
import { InvoiceComponent } from './invoice/invoice';
import { AddInvoiceComponent } from './invoice/add-invoice/add-invoice';
import { EditInvoiceComponent } from './invoice/edit-invoice/edit-invoice'; 
import { StockComponent } from './stock/stock';
import { AddStockComponent } from './stock/add-stock/add-stock';
import { EditStockComponent } from './stock/edit-stock/edit-stock'; 
import { DeliveryForFeeComponent } from './deliveryforfee/deliveryforfee';
import { AddDeliveryForFeeComponent } from './deliveryforfee/add-deliveryforfee/add-deliveryforfee';
import { EditDeliveryForFeeComponent } from './deliveryforfee/edit-deliveryforfee/edit-deliveryforfee';
import { CustomerComponent } from './customer/customer';
import { AddCustomerComponent } from './customer/add-customer/add-customer';
import { EditCustomerComponent } from './customer/edit-customer/edit-customer';
import { CustomerAddressComponent } from './customer/customeraddress/customeraddress';
import { AddCustomerAddressComponent } from './customer/customeraddress/add-customeraddress/add-customeraddress';
import { EditCustomerAddressComponent } from './customer/customeraddress/edit-customeraddress/edit-customeraddress';
import { EmployeeComponent } from './employee/employee';
import { AddEmployeeComponent } from './employee/add-employee/add-employee';
import { EditEmployeeComponent } from './employee/edit-employee/edit-employee';
import { ProductComponent } from './product/product';
import {AddProductComponent } from './product/add-product/add-product';
import { EditProductComponent } from './product/edit-product/edit-product';


import { Login } from './login/login';
import { AuthGuard } from './auth-guard';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent, canActivate: [AuthGuard]
    },
    {
        path: 'home',
        component: HomeComponent, canActivate: [AuthGuard]
    },
    {
        path: 'invoice',
        component: InvoiceComponent, canActivate: [AuthGuard]
    },
        {
        path: 'addinvoice',
        component: AddInvoiceComponent, canActivate: [AuthGuard]
    },
    {
        path: 'editinvoice',
        component: EditInvoiceComponent, canActivate: [AuthGuard]
    },
    {
        path: 'editstock',
        component: EditStockComponent, canActivate: [AuthGuard]
    },
    {
        path: 'stock',
        component: StockComponent, canActivate: [AuthGuard]
    },
            {
        path: 'addstock',
        component: AddStockComponent, canActivate: [AuthGuard]
    },
    {
        path: 'delivery',
        component: DeliveryForFeeComponent, canActivate: [AuthGuard]
    },
        {
        path: 'adddelivery',
        component: AddDeliveryForFeeComponent, canActivate: [AuthGuard]
    },
          {
        path: 'editdelivery',
        component: EditDeliveryForFeeComponent, canActivate: [AuthGuard]
    },
    {
        path: 'customer',
        component: CustomerComponent, canActivate: [AuthGuard]
    },
    {
        path: 'addcustomer',
        component: AddCustomerComponent
    },
       {
        path: 'editcustomer',
        component: EditCustomerComponent
    },
    {
        path: 'customeraddress',
        component: CustomerAddressComponent
    },
     {
        path: 'addcustomeraddress',
        component: AddCustomerAddressComponent
    },
     {
        path: 'editcustomeraddress',
        component: EditCustomerAddressComponent
    },
    {
        path: 'employee',
        component: EmployeeComponent, canActivate: [AuthGuard]
    },
       {
        path: 'addemployee',
        component: AddEmployeeComponent, canActivate: [AuthGuard]
    },
    {
        path: 'editemployee',
        component: EditEmployeeComponent, canActivate: [AuthGuard]
    },
    {
        path: 'product',
        component: ProductComponent, canActivate: [AuthGuard]
    },
    {
        path: 'addproduct',
        component: AddProductComponent, canActivate: [AuthGuard]
    },
        {
        path: 'editproduct',
        component: EditProductComponent, canActivate: [AuthGuard]
    },

     {
        path: 'login',
        component: Login,
    },
    {
        path: '**',
        component: HomeComponent, canActivate: [AuthGuard]
    }
];
